let recaptchaLoaded = false
let recaptchaSiteKey: string | null = null

/**
 * Dynamically loads the Google ReCAPTCHA v3 script if the campaign has a site key configured.
 * Only loads once — subsequent calls are no-ops.
 */
export function loadRecaptchaScript(siteKey: string): void {
  if (recaptchaLoaded || !siteKey) {
    return
  }
  recaptchaLoaded = true
  recaptchaSiteKey = siteKey

  const script = document.createElement('script')
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
  script.async = true
  script.defer = true
  document.head.appendChild(script)
}

/**
 * Executes ReCAPTCHA and returns a token, or undefined if ReCAPTCHA is not loaded.
 */
export async function executeRecaptcha(action = 'submit'): Promise<string | undefined> {
  const grecaptcha = (window as any).grecaptcha
  if (!grecaptcha || !recaptchaSiteKey) {
    return undefined
  }

  try {
    await grecaptcha.ready?.(() => {})
    return await grecaptcha.execute(recaptchaSiteKey, { action })
  } catch {
    return undefined
  }
}

/**
 * Initializes ReCAPTCHA from campaign data if a site key is present.
 */
export function initRecaptchaFromCampaign(campaign: any): void {
  const siteKey = campaign?.recaptcha_site_key
  if (siteKey) {
    loadRecaptchaScript(siteKey)
  }
}
